import Footer from '@/widgets/footer';
import Privacy from '@/widgets/privacy';

export default function () {
  return (
    <Privacy>
      <Footer hasShadow />
    </Privacy>
  );
}
